require('./lbaCompanyReferenceGrid.scss');

const lbaCompanyReferenceGrid = angular.module('app.lbaCompanyReferenceGrid', []);

lbaCompanyReferenceGrid.component('lbaCompanyReferenceGrid', {
  bindings: {
    settings: '=',
    toggleDetail: '=',
    saveItem: '=',
    deleteItem: '=',
    data: '=',
  },
  controllerAs: 'vm',
  controller: ['companyReferenceService','$location', '$scope', '$timeout', '$routeParams', '$http', 'dataService', 'dataSourceService','$rootScope', lbaCompanyReferenceGridCtrl],
  template: require('./lbaCompanyReferenceGrid.html')
});

function lbaCompanyReferenceGridCtrl(companyReferenceService,$location, $scope, $timeout, $routeParams, $http, dataService, dataSourceService,$rootScope) {
  const vm = this;
 
  $rootScope.$on('companyReferenceGrid.refresh', vm.LoadCompanyReferences);

  vm.dataService = dataService;
  vm.ready = false;
  //vm.canAdd = vm.settings.hasOwnProperty('gridAdd');
  vm.filters = '';
  if (dataService.backGridFilter != null && dataService.backGridFilter[vm.settings.displayName]) {
    vm.filters = dataService.backGridFilter[vm.settings.displayName]
  }
  var page = 1;
  if (dataService.backGridPage != null && dataService.backGridPage[vm.settings.displayName]) {
    page = dataService.backGridPage[vm.settings.displayName]
  }
  
  vm.addNew = addNew;
  vm.getObjectPropertyValue = getObjectPropertyValue;
  vm.isShowingDisabled = false;
  vm.onClick = onClick;
  vm.LoadCompanyReferences = LoadCompanyReferences;

  vm.LoadCompanyReferences();
  
  function LoadCompanyReferences(){
    
    companyReferenceService.getCompanyReferences().then((data)=>{
      vm.data = data;
      addDataToGrid(vm.settings.gridCols,vm.data,page);
    });
  }


  function addDataToGrid(headers, data, page) {

    vm.resource = {
      header: headers,
      rows: data,
      pagination: {
        page
      }
    };

    vm.ready = true;
  }

  function addNew() {
    vm.settings.gridItem(null,LoadCompanyReferences);
    
   
  }



  function getObjectPropertyValue(obj, path, defaultValue = null) {
    return _.get(obj, path, defaultValue);
  }
  function onClick(data, copyItem, copyResource){
    vm.settings.gridItem(data,LoadCompanyReferences);

  }
}

export default lbaCompanyReferenceGrid;


// WEBPACK FOOTER //
// ./src/components/lbaCompanyReferenceGrid/lbaCompanyReferenceGrid.js